/**
 * Site Configuration
 * 
 * SITE_MODE Options:
 * - 'join-movement': Shows Join The Movement version (hides donation functionality)
 * - 'with-donations': Shows version with Donate buttons and full donation functionality
 * 
 * To switch versions, simply change the SITE_MODE value below.
 */

export const config = {
  // Current site mode - change this to switch between versions
  SITE_MODE: 'with-donations', // Options: 'join-movement' | 'with-donations'
  
  // Google Analytics Tracking ID (add when ready)
  GA_TRACKING_ID: process.env.REACT_APP_GA_TRACKING_ID || '',
};

// Helper functions
export const isJoinMovementMode = () => config.SITE_MODE === 'join-movement';
export const isDonationMode = () => config.SITE_MODE === 'with-donations';
